import { type CustomerAccessControlDefinition, type DoitAccessControlDefinition } from "../../types";
import DeprecatedRoutesRedirect from "./DeprecatedRoutesRedirect";
import { deprecatedCustomerRoutes } from "./routeConfigs/customerRoutes";
import { deprecatedDoerRoutes } from "./routeConfigs/doerRoutes";

export const deprecatedDoerRoutesConfig: DoitAccessControlDefinition = {
  component: DeprecatedRoutesRedirect,
  key: "deprecatedRoutesRedirect:doer",
  routes: deprecatedDoerRoutes,
};

export const deprecatedCustomerRoutesConfig: CustomerAccessControlDefinition = {
  component: DeprecatedRoutesRedirect,
  key: "deprecatedRoutesRedirect:customer",
  routes: deprecatedCustomerRoutes,
};
